// TODO - Tags should be moved to server and internationalization should be added + Specific Application to change tags

import IEntityIcon from "../interface/entity-icon";

const EntityIcons: { [key: string]: IEntityIcon } = {
    spreadsheet: {
        id: 'spreadsheet',
        tags: [
            'spreadsheet',
            'schedules',
            'calendars',
            'arrays',
            'charts',
            'months',
            'lists',
            'table',
            'weeks',
            'data',
            'days'
        ]
    },
    widgetcard: {
        id: 'widgetcard',
        tags: [
            'calculation',
            'widget'
        ]
    },
    graphiccard: {
        id: 'graphiccard',
        tags: [
            'graphic',
            'chart',
            'bars'
        ]
    },
    agreement: {
        id: 'agreement',
        tags: [
            'acquisitions',
            'conventions',
            'arrangement',
            'stipulation',
            'agreements',
            'associado',
            'associate',
            'contracts',
            'covenants',
            'purchases',
            'compras',
            'accord',
            'offers',
            'deals',
            'hands',
            'pacts'
        ]
    },
    booking: {
        id: 'booking',
        tags: [
            'communications',
            'oportunidades',
            'opportunities',
            'appointments',
            'publications',
            'requirements',
            'reservations',
            'actividades',
            'contractors',
            'opportunity',
            'activities',
            'enrollment',
            'references',
            'documents',
            'marcações',
            'customers',
            'companies',
            'reporting',
            'documents',
            'schedules',
            'activity',
            'dossiers',
            'homework',
            'marcação',
            'bookings',
            'registos',
            'preorder',
            'services',
            'serviços',
            'company',
            'defects',
            'project',
            'records',
            'reserve',
            'tarefas',
            'orders',
            'acções',
            'assign',
            'venues',
            'acção',
            'cases',
            'items',
            'order',
            'parts',
            'roles',
            'seats',
            'tasks',
            'pre'
        ]
    },
    classification: {
        id: 'classification',
        tags: [
            'classifications',
            'categorize',
            'industries',
            'divisions',
            'catalogue',
            'dossiers',
            'category',
            'industry',
            'registos',
            'sorting',
            'records',
            'phases',
            'status',
            'books',
            'cases',
            'tipos',
            'types',
            'fase'
        ]
    },
    clients: {
        id: 'clients',
        tags: [
            'appointments',
            'contractors',
            'applicants',
            'advogados',
            'companies',
            'consumers',
            'contactos',
            'prospects',
            'marcações',
            'customers',
            'contacts',
            'patients',
            'schedule',
            'marcação',
            'company',
            'general',
            'clients',
            'lawyers',
            'persons',
            'parents',
            'vendors',
            'buyers',
            'people',
            'guests',
            'users',
            'leads'
        ]
    },
    events: {
        id: 'events',
        tags: [
            'appointments',
            'appearances',
            'ceremonies',
            'calendars',
            'schedules',
            'billable',
            'journals',
            'marcação',
            'ceremony',
            'parties',
            'actions',
            'events',
            'months',
            'diary',
            'weeks',
            'party',
            'hours',
            'cases',
            'days'
        ]
    },
    eventstar: {
        id: 'eventstar',
        tags: [
            'acquisitions',
            'appearances',
            'ceremonies',
            'indicators',
            'milestones',
            'purchases',
            'ceremony',
            'statuses',
            'actions',
            'compras',
            'parties',
            'events',
            'cases',
            'party'
        ]
    },
    invitations: {
        id: 'invitations',
        tags: [
            'advertisements',
            'communications',
            'responsibles',
            'responsáveis',
            'invitations',
            'responsável',
            'dispatcher',
            'contactos',
            'reporting',
            'managers',
            'anunçios',
            'contacts',
            'gestores',
            'appeals',
            'roles',
            'ads'
        ]
    },
    invoice: {
        id: 'invoice',
        tags: [
            'accounts',
            'credit',
            'documents',
            'enrollment',
            'facturas',
            'faturas',
            'invoices',
            'notas',
            'notes',
            'projects',
            'documents',
            'records',
            'references',
            'registos'
        ]
    },
    maintenance: {
        id: 'maintenance',
        tags: [
            'maintenance',
            'components',
            'processes',
            'services',
            'serviços',
            'repairs',
            'actions',
            'skills',
            'tasks',
            'parts',
            'peças',
            'works',
            'jobs'
        ]
    },
    payment: {
        id: 'payment',
        tags: [
            'acquisitions',
            'oportunidade',
            'opportunity',
            'insurances',
            'purchases',
            'salaries',
            'apólices',
            'billable',
            'despesas',
            'expenses',
            'payments',
            'compras',
            'credit',
            'salary',
            'wages'
        ]
    },
    place: {
        id: 'place',
        tags: [
            'destinations',
            'headquarters',
            'propriedades',
            'appartments',
            'references',
            'categorize',
            'milestones',
            'properties',
            'locations',
            'divisions',
            'catalogue',
            'addresses',
            'countries',
            'category',
            'property',
            'regions',
            'country',
            'cities',
            'houses',
            'locais',
            'phases',
            'places',
            'areas',
            'local',
            'tipos',
            'types',
            'city',
            'fase'
        ]
    },
    product: {
        id: 'product',
        tags: [
            'acquisitions',
            'componentes',
            'components',
            'inventory',
            'purchases',
            'shipments',
            'products',
            'compras',
            'parts',
            'peças'
        ]
    },
    projects: {
        id: 'projects',
        tags: [
            'acquisitions',
            'oportunidade',
            'opportunity',
            'reporting',
            'purchases',
            'progress',
            'projects',
            'reports',
            'compras'
        ]
    },
    shipment: {
        id: 'shipment',
        tags: [
            'transportations',
            'encomendas',
            'transports',
            'shipments',
            'services',
            'dispatch',
            'serviços',
            'vehicles',
            'viagens',
            'serviço',
            'travels',
            'viagem',
            'orders',
            'sender',
            'trips'
        ]
    },
    student: {
        id: 'student',
        tags: [
            'communications',
            'colaboradores',
            'participants',
            'publications',
            'documentos',
            'professors',
            'reporting',
            'advogados',
            'coworkers',
            'documents',
            'employees',
            'employers',
            'students',
            'trainers',
            'journals',
            'lawyers',
            'members',
            'persons',
            'people',
            'diary',
            'menus',
            'roles',
            'seats',
            'staff'
        ]
    },
    team: {
        id: 'team',
        tags: [
            'colaboradores',
            'organizations',
            'participants',
            'associados',
            'associates',
            'coworkers',
            'customers',
            'employees',
            'companies',
            'empresas',
            'families',
            'personal',
            'clients',
            'company',
            'members',
            'membros',
            'family',
            'guests',
            'people',
            'users',
            'staff',
            'team'
        ]
    },
    todo: {
        id: 'todo',
        tags: [
            'advertisements',
            'oportunidades',
            'opportunities',
            'responsibles',
            'responsáveis',
            'responsável',
            'actividades',
            'opportunity',
            'activities',
            'homeworks',
            'gestores',
            'managers',
            'activity',
            'actions',
            'tarefas',
            'tasks',
            'acção',
            'ação',
            'todo',
            'ads',
            'to',
            'do'
        ]
    },
    classification2: {
        id: 'classification2',
        tags: [
            'classifications',
            'categories',
            'category',
            'statuses',
            'groups',
            'types'
        ]
    },
    company: {
        id: 'company',
        tags: [
            'corporations',
            'enterprises',
            'factories',
            'companies',
            'company',
            'factory'
        ]
    },
    contact: {
        id: 'contact',
        tags: [
            'contacts',
            'profiles',
            'members',
            'cards',
            'roles'
        ]
    },
    contact2: {
        id: 'contact2',
        tags: [
            'contacts',
            'profiles',
            'members',
            'cards',
            'roles',
            'notes'
         ]
    },
    courses: {
        id: 'courses',
        tags: [
            'classifications',
            'departments',
            'categories',
            'category',
            'statuses',
            'courses',
            'groups',
            'types'
        ]
    },
    court: {
        id: 'court',
        tags: [
            'evaluations',
            'advocates',
            'recipies',
            'recipe',
            'court'
        ]
    },
    delivery: {
        id: 'delivery',
        tags: [
            'deliveries',
            'delivery',
            'products',
            'tasks'
        ]
    },
    project: {
        id: 'project',
        tags: [
            'professors',
            'lecturers',
            'investors',
            'projects',
            'teachers',
            'trainers',
            'advisors',
            'mentors',
            'coaches',
            'tutors'
        ]
    },
    subject: {
        id: 'subject',
        tags: [
            'repository',
            'subject',
            'themes',
            'areas',
            'books',
            'data',
            'read'
        ]
    },
    type: {
        id: 'type',
        tags: [
            'classification',
            'categories',
            'category',
            'statuses',
            'filters',
            'type'
        ]
    },
    waiting: {
        id: 'waiting',
        tags: [
            'patients',
            'meetings',
            'waiting'
        ]
    },
    journalist: {
        id: 'journalist',
        tags: [
            'journalists',
            'evaluations',
            'interviews',
            'responses',
            'reactions',
            'feedback',
            'comments',
            'answers',
            'respond',
            'reviews',
            'reports',
            'claims',
            'reply',
            'views',
            'news'
        ]
    },
    money: {
        id: 'money',
        tags: [
            'principals',
            'interests',
            'finances',
            'receipts',
            'payments',
            'invoices',
            'currency',
            'capitals',
            'savings',
            'support',
            'assets',
            'stocks',
            'coins',
            'funds',
            'money',
            'bills',
            'cash'
        ]
    },
    people: {
        id: 'people',
        tags: [
            'participants',
            'contacts',
            'brigades',
            'support',
            'members',
            'persons',
            'clients',
            'workers',
            'couples',
            'family',
            'people',
            'groups',
            'pairs',
            'staff',
            'users',
            'team',
            'duo'
        ]
    },
    submission: {
        id: 'submission',
        tags: [
            'submission',
            'idea'
        ]
    },
    events2: {
        id: 'events-2',
        tags: [
            'acquisitions',
            'appearances',
            'ceremonies',
            'indicators',
            'milestones',
            'purchases',
            'ceremony',
            'statuses',
            'actions',
            'compras',
            'parties',
            'events',
            'cases',
            'party'
        ]
    },
    founders: {
        id: 'founders',
        tags: [
            'founders',
            'clients',
            'lawyers',
            'persons',
            'parents',
            'vendors',
            'buyers',
            'people',
            'guests',
            'users',
            'leads'
        ]
    },
    investment: {
        id: 'investment',
        tags: [
            'investments',
            'interests',
            'finances',
            'payments',
            'currency',
            'capitals',
            'growth',
            'funds',
            'money',
            'bills',
            'cash'
        ]
    },
    planing: {
        id: 'planing',
        tags: [
            'schedules',
            'calendars',
            'planning',
            'months',
            'lists',
            'weeks',
            'data',
            'days'
        ]
    },
    startup: {
        id: 'startup',
        tags: [
            'startup',
            'rocket',
            'speed',
            'space',
            'run'
        ]
    },
    filter: {
        id: 'filter',
        tags: [
            'filters'
        ]
    },
    category: {
        id: 'category',
        tags: [
            'classification',
            'categories',
            'category',
            'projects',
            'files'
        ]
    },
    channels: {
        id: 'channels',
        tags: [
            'connections',
            'channels',
            'trackers'
        ]
    },
    contact3: {
        id: 'contact3',
        tags: [
            'influencers',
            'selections',
            'customers',
            'investors',
            'founders',
            'contacts',
            'profiles',
            'clients',
            'mentors',
            'members',
            'cards',
            'roles'
        ]
    },
    contact4: {
        id: 'contact4',
        tags: [
            'customers',
            'suppliers',
            'partners',
            'founders',
            'contacts',
            'profiles',
            'clients',
            'members',
            'cards',
            'roles'
        ]
    },
    feedback: {
        id: 'feedback',
        tags: [
            'influencer',
            'feedback',
            'comments',
            'requests',
            'mentor',
            'notes'
        ]
    },
    investment2: {
        id: 'investment2',
        tags: [
            'investments',
            'interests',
            'investors',
            'finances',
            'payments',
            'currency',
            'capitals',
            'growth',
            'funds',
            'money',
            'bills',
            'banks',
            'cash'
        ]
    },
    investment3: {
        id: 'investment3',
        tags: [
            'investments',
            'interests',
            'investors',
            'finances',
            'payments',
            'currency',
            'capitals',
            'growth',
            'funds',
            'money',
            'bills',
            'cash',
        ]
    },
    launch1: {
        id: 'launch1',
        tags: [
            'shipments',
            'messages',
            'senders',
            'orders',
            'launch',
            'planes',
            'start',
        ]
    },
    launch2: {
        id: 'launch2',
        tags: [
            'influencers',
            'feedbacks',
            'comments',
            'requests',
            'notes'
        ]
    },
    marketing: {
        id: 'marketing',
        tags: [
            'nationalities',
            'references',
            'objectives',
            'marketing',
            'countries',
            'country',
            'labels',
            'flags',
            'goals',
            'news'
        ]
    },
    opportunity: {
        id: 'opportunity',
        tags: [
            'opportunities',
            'opportunity',
            'objectives',
            'mentoring',
            'mentors',
            'goals'
        ]
    },
    options: {
        id: 'options',
        tags: [
            'alternatives',
            'selections',
            'requests',
            'options',
            'types'
        ]
    },
    payment2: {
        id: 'payment2',
        tags: [
            'acquisitions',
            'payments',
            'insurances',
            'purchases',
            'salaries',
            'apólices',
            'billable',
            'despesas',
            'expenses',
            'compras',
            'credit',
            'salary',
            'wages'
        ]
    },
    payment3: {
        id: 'payment3',
        tags: [
            'opportunities',
            'acquisitions',
            'oportunidade',
            'opportunity',
            'investments',
            'financial',
            'investors',
            'interests',
            'finances',
            'billable',
            'capitals',
            'despesas',
            'currency',
            'expenses',
            'payments',
            'salaries',
            'compras',
            'salary',
            'credit',
            'growth',
            'bills',
            'funds',
            'money',
            'wages',
            'cash'
        ]
    },
    planing2: {
        id: 'planing2',
        tags: [
            'presentations',
            'informations',
            'schedules',
            'calendars',
            'plannings'
        ]
    },
    speaker: {
        id: 'speaker',
        tags: [
            'communication',
            'advertisings',
            'newsletters',
            'campaigns',
            'marketing',
            'speakers'
        ]
    },
    submission2: {
        id: 'submission2',
        tags: [
            'opportunities',
            'applications',
            'opportunity',
            'evaluations',
            'submissions',
            'feedbacks',
            'trackings',
            'follow-ip',
            'orders',
            'inputs',
            'items'
        ]
    },
    submission3: {
        id: 'submission3',
        tags: [
            'applications',
            'submissions',
            'inputs'
        ]
    },
    activities: {
        id: 'activities',
        tags: [
            'activities'
        ]
    },
    agreement2: {
        id: 'agreement2',
        tags: [
            'agreement'
        ]
    },
    category2: {
        id: 'category2',
        tags: [
            'classification',
            'categories',
            'category',
            'projects',
            'files'
        ]
    },
    comission: {
        id: 'comission',
        tags: [
            'comission'
        ]
    },
    evaluation: {
        id: 'evaluation',
        tags: [
            'evaluation'
        ]
    },
    laboratory: {
        id: 'laboratory',
        tags: [
            'laboratory'
        ]
    },
    links: {
        id: 'links',
        tags: [
            'links'
        ]
    },
    member: {
        id: 'member',
        tags: [
            'member'
        ]
    },
    offer: {
        id: 'offer',
        tags: [
            'offer'
        ]
    },
    partners: {
        id: 'partners',
        tags: [
            'partners'
        ]
    },
    payment4: {
        id: 'payment4',
        tags: [
            'payment'
        ]
    },
    place2: {
        id: 'place2',
        tags: [
            'place'
        ]
    },
    projects2: {
        id: 'projects2',
        tags: [
            'projects'
        ]
    },
    student2: {
        id: 'student2',
        tags: [
            'student'
        ]
    },
    template: {
        id: 'template',
        tags: [
            'template'
        ]
    },
    time: {
        id: 'time',
        tags: [
            'time'
        ]
    }
};

const ProcessedIcons: IEntityIcon[] = [];

Object.keys(EntityIcons).forEach(key => {
    const icon = (EntityIcons as any)[key];
    ProcessedIcons.push({
        id: icon.id,
        tags: icon.tags.join('~')
    });
});

export default ProcessedIcons;